import { type GridCellParams } from '@mui/x-data-grid'
import { generateCell } from './generateCells'
import { type CustomColumnDef } from './types'

export const generateColumns = <T,>(columns: CustomColumnDef[], extraColumnProps: object | undefined, overrides: Record<string, (a: T) => JSX.Element>, setSelectedRow: any, setActionModal: any): CustomColumnDef[] => {
  const filterdColumn = columns?.filter((column: CustomColumnDef) => column.shown)

  return filterdColumn?.map((column, index) => ({
    field: column?.field,
    headerName: column?.headerName,
    width: 180,
    minWidth: 160,
    maxWidth: 350,
    type: column.type,
    sortable: column.allowSort ?? false,
    hideable: column.alwaysShow === false,
    shown: column.shown ?? false,
    sortingOrder: ['asc', 'desc'],
    ...extraColumnProps,
    renderCell: ({ colDef, row }: GridCellParams) => generateCell(colDef, row, setSelectedRow, setActionModal, index, overrides)
  }))
}
